
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import clsx from 'clsx'
import Image from 'next/image'
import Container from '../components/atoms/container'
import Heading from '../components/atoms/heading'
import Paragraph, {ParagraphProps} from '../components/atoms/paragraph'
import {FooterDataStateProps, FooterProvider} from '../contexts/footer-context'
import PageLayout from '../layouts/page-layout'
import defaultImageLoader from '../lib/default-image-loader'
import fetchGeneralSettings from '../lib/fetch-general-settings'
import fetchSocialLinks from '../lib/fetch-social-links'
import bishopSymbol from '../public/assets/bishop-logo-symbol.png'
import bishopLogo from '../public/assets/bishop-logo.png'
import nkfiaInfoblokk from '../public/assets/nkfia-infoblokk.png'

function ParagraphWithMargin({className, children, ...props}: ParagraphProps) {
  return (
    <Paragraph className={clsx('my-3', className)} {...props}>
      {children}
    </Paragraph>
  )
}

export default function SMETender({social, general}: FooterDataStateProps) {
  return (
    <FooterProvider value={{social, general}}>
      <PageLayout
        disableDefaultPadding
        className="py-28 md:py-32"
        title="KKV Start Pályázat"
        description="Információtechnológiai KKV-k együttműködésen alapuló sales folyamatainak innovatív megreformálása az egyéni karrier fejlesztési lehetőségek integrálásával"
        openGraph={{
          locale: 'hu_HU', 
          images: [{url: bishopSymbol.src}],
          url: "kkv-start-palyazat",
        }}
      >
        <Container>
          <figure className="max-w-xxs">
            <Image
              src={bishopLogo}
              alt="Bishop &amp; Co. logo"
              width={350}
              height={102}
              quality={100}
              layout="responsive"
              loader={defaultImageLoader}
            />
          </figure>

          <Heading className="mt-4 mb-2" disableMaxWidth>
            KKV Start Pályázat
          </Heading>

          <Heading component="strong" variant="h3" disableMaxWidth>
            Kedvezményezett neve:
          </Heading>

          <ParagraphWithMargin>Bishop Co Kft.</ParagraphWithMargin>

          <Heading component="strong" variant="h3" disableMaxWidth>
            Projekt címe:
          </Heading>

          <ParagraphWithMargin>
            Információtechnológiai KKV-k együttműködésen alapuló sales
            folyamatainak innovatív megreformálása az egyéni karrier fejlesztési
            lehetőségek integrálásával
          </ParagraphWithMargin>

          <Heading component="strong" variant="h3" disableMaxWidth>
            Projekt azonosítószáma:
          </Heading>

          <ParagraphWithMargin>
            2020-1.1.1-KKV-START-2020-00055
          </ParagraphWithMargin>

          <Heading component="strong" variant="h3" disableMaxWidth>
            Támogatás összege:
          </Heading>

          <ParagraphWithMargin>19.056.000 Ft</ParagraphWithMargin>

          <Heading component="strong" variant="h3" disableMaxWidth>
            A projekt megvalósításának időtartama:
          </Heading>

          <ParagraphWithMargin>2021.02.01 – 2022.01.31.</ParagraphWithMargin>

          <Heading component="strong" variant="h3" disableMaxWidth>
            A projekt bemutatása:
          </Heading>

          <ParagraphWithMargin>
            A Bishop Co Kft. projektjének átfogó célja egy olyan webes és
            mobilra optimalizált platform létrehozása, amely innovatív módon
            nyújt segítséget az IT szektor mikro-, kis- és középvállalkozásainak
            értékesítési folyamataihoz úgy, hogy együttműködési felületet
            biztosít a KKV-k számára a kapacitásaik egyesítéséhez, illetve
            megosztásához és integrálja a különféle technológiai domainekhez
            kapcsolódó egyéni szakmai és karrierfejlesztési lehetőségeket. A
            létrehozni tervezett platform két egyértelműen szeparálható modulra
            bontható, a sales és az oktató modulra.
          </ParagraphWithMargin>

          <ParagraphWithMargin>
            A sales modul segítségét nyújthat nagyobb volumenű, elsősorban
            külföldi projektek megszerzéséhez. A rendszerbe regisztrált és
            előfizetett partnerek együttműködve összegyűjthetik a rendelkezésre
            álló humán erőforrásaikat, és közösen fellépve, nagyobb kapacitást
            felmutatva lehetnek képesek egy-egy nagyobb projektbe bekapcsolódni.
            A platform használatával számos IT szektorbeli vállalkozás képes
            lesz új ügyfeleket szerezni a kibővített erőforrások révén. Az
            értékesítési munkatársak és az ügyvezetők mindig naprakészen fogják
            látni a platformon belül elérhető egyének tudását, képességeit, így
            egy tárgyalás során pontos kapacitás és kompetencia tervet tudnak
            felmutatni egy potenciális ügyfélnek. A platformnak nem célja és nem
            is nyújt segítséget abban, hogy a regisztrált partnerek a
            rendszerben szereplő felhasználókat a saját cégükhöz csábítsák.
          </ParagraphWithMargin>

          <ParagraphWithMargin className="mb-8">
            A rendszer egyedisége, – melyre az oktató modul épül – hogy a
            regisztrált felhasználók kompetenciái alapján a munkavállalók
            karrier útjának automatizált támogatása biztosított. A modulon belül
            a munkavállalók a képességeik megadásával javaslatot kapnak egy
            előre meghatározott karrier út követésére, és az ehhez a karrier
            úthoz kapcsolódó kompetenciák fejlesztéséhez folyamatos útmutatást
            és ajánlásokat kapnak. Ez egybevág egy szervezet érdekeivel is,
            hiszen minden vállalat célja, hogy a házon belül rendelkezésre álló
            tudását bővítse és fenntartsa a cég folyamatos fejlődését.
          </ParagraphWithMargin>

          <figure className="max-w-lg ml-auto">
            <Image
              src={nkfiaInfoblokk}
              alt="Nemzeti Kutatási, Fejlesztési és Innovációs Hivatal logója"
              width={750}
              height={175}
              quality={100}
              layout="responsive"
              loader={defaultImageLoader}
            />
          </figure>
        </Container>
      </PageLayout>
    </FooterProvider>
  )
}

 function _getStaticProps() {
  return {
    props: {
      social: fetchSocialLinks(),
      general: fetchGeneralSettings(),
    },
  }
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/kkv-start-palyazat',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  